export default "__VITE_ASSET__DNh7VlHg__"